import ceo from './modules/ceo';
import eventGuest from './modules/eventGuest';
import trainingGuest from './modules/trainingGuest';
import host from './modules/host';

export default {
  namespaced: true,
  modules: {
    ceo,
    eventGuest,
    trainingGuest,
    host,
  },
};
